/**
 * Hero video and reduced motion
 *
 * The hero video (core/media-text with `yours-hero-split`) gets autoplay,
 * muted and loop server side (Blocks::hero_video_attributes()). Visitors who
 * prefer reduced motion see it paused on the first frame instead, and the
 * video follows changes of that setting.
 */
export default function heroVideo() {
    const videos = document.querySelectorAll(".yours-hero-split video");

    if (!videos.length || !window.matchMedia) {
        return;
    }

    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    const apply = () => {
        videos.forEach((video) => {
            if (reducedMotion.matches) {
                video.removeAttribute("autoplay");
                video.pause();
                video.currentTime = 0;
            } else {
                video.muted = true;
                // play() rejects if the browser blocks autoplay; nothing to do then.
                video.play().catch(() => {});
            }
        });
    };

    apply();
    reducedMotion.addEventListener("change", apply);
}
